import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Header = styled.div`
	padding-bottom: var(--margin-4);
	width: 100%;
	@media ${Breakpoints.tablet && Breakpoints.mobile} {
		padding: var(--margin-4) var(--margin-4) 0 var(--margin-4);
	}
`;
export const LeftContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: var(--margin-2);
	gap: var(--margin-3);
`;
export const RightContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;
export const Logo = styled(Image)`
	border-radius: 4px;
`;

export const Credentials = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const CredentialFormItems = styled.div`
	display: flex;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const CredentialButtonContainer = styled.div`
	margin-left: var(--margin-2);
`;

export const VerifyAlert = styled.div`
	padding: 0 var(--padding-2);
	margin-bottom: var(--margin-2);
`;

export const InstructionsCard = styled(Card)`
	display: flex;
	flex-direction: column;
	gap: var(--padding-3);
`;

export const BusinessInstructionWrapper = styled.div`
	width: 100%;
`;
